import Config from '@/settings';
var REMEMBER_ME_KEY = 'rememberMe';
var REFRESH_TOKEN_KEY = "".concat(Config.tokenKey, "_refresh");
function getPreferredRefreshStorage() {
  var remember = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getRememberMe();
  return remember ? localStorage : sessionStorage;
}
function getFallbackRefreshStorage() {
  var remember = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getRememberMe();
  return remember ? sessionStorage : localStorage;
}
function clearAccessToken() {
  localStorage.removeItem(Config.tokenKey);
  sessionStorage.removeItem(Config.tokenKey);
}
function clearRefreshToken() {
  localStorage.removeItem(REFRESH_TOKEN_KEY);
  sessionStorage.removeItem(REFRESH_TOKEN_KEY);
}
function clearAuthStorage() {
  clearAccessToken();
  clearRefreshToken();
}

// 获取记住登录状态的设置
export function getRememberMe() {
  return localStorage.getItem(REMEMBER_ME_KEY) === 'true';
}

// 设置记住登录状态
export function setRememberMe(remember) {
  localStorage.setItem(REMEMBER_ME_KEY, remember ? 'true' : 'false');
}

// 获取 Token（根据记住状态从不同存储获取）
export function getToken() {
  var sessionToken = sessionStorage.getItem(Config.tokenKey);
  if (sessionToken) return sessionToken;

  // 兼容旧版本曾经写入 localStorage 的 access token，读取后迁移到会话存储并清理持久副本。
  var legacyToken = localStorage.getItem(Config.tokenKey);
  if (legacyToken) {
    sessionStorage.setItem(Config.tokenKey, legacyToken);
    localStorage.removeItem(Config.tokenKey);
  }
  return legacyToken;
}

// access token 只保存在当前会话，降低 XSS 后的持久化暴露面。
export function setToken(token) {
  clearAccessToken();
  if (token) {
    sessionStorage.setItem(Config.tokenKey, token);
  }
}
export function getRefreshToken() {
  var preferredStorage = getPreferredRefreshStorage();
  var preferredToken = preferredStorage.getItem(REFRESH_TOKEN_KEY);
  if (preferredToken) return preferredToken;
  return getFallbackRefreshStorage().getItem(REFRESH_TOKEN_KEY);
}
export function setRefreshToken(token) {
  var remember = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getRememberMe();
  clearRefreshToken();
  if (token) {
    getPreferredRefreshStorage(remember).setItem(REFRESH_TOKEN_KEY, token);
  }
}

// 给同源 iframe/静态页使用。只写 sessionStorage，避免重新把 access token 落到 localStorage。
export function exposeTokenToSession() {
  var token = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getToken();
  clearAccessToken();
  if (token) {
    sessionStorage.setItem(Config.tokenKey, token);
  }
}

// 移除 Token（同时清除两个存储）
export function removeToken() {
  clearAuthStorage();
}